import {__} from "./__";

export const getAiTranslateProductInputs = () => {
    return {
        product_name: __('Názov produktu'),
        product_short_description: __('Krátky popis produktu'),
        product_description: __('Dlhý popis produktu'),
        product_seo_title: __('SEO (meta) názov produktu'),
        product_seo_description: __('SEO (meta) popis produktu'),
    };
};
